export default {
    setSimplePaymentDetailFilterOptions({ commit }, payload) {
        commit('SET_SIMPLE_PAYMENT_DETAIL_FILTER_OPTIONS', payload);
    },
};
